// extracted by css-extract-rspack-plugin
export default {"avatarRow":"SidebarUsedBy-module__avatarRow__fUz11","moreCount":"SidebarUsedBy-module__moreCount__SKpqf"};